// Prefix with Vite's base so logos still resolve when the app is hosted under a sub‑path
// (e.g. https://domain.com/app/). Using BASE_URL prevents broken absolute /assets URLs
// while keeping the files in /public.
const withBase = (path) => `${import.meta.env.BASE_URL}${path.replace(/^\//, '')}`;

export const MEALOPS_LOGO_FULL_COLOR = withBase('assets/MealOps_logos/logos_png/MealOps.png');
export const MEALOPS_LOGO_MARK_GREEN = withBase('assets/MealOps_logos/logos_png/white_green_logo.png');
export const MEALOPS_GREEN_ONLY_LOGO = withBase('assets/MealOps_logos/logos_png/MealOps_logo_final.jpg');
